import * as React from "react";
import { Alert } from "antd";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";

export const WorkloadSubdomainExactlyOneRouteCheck: React.FC = () => {
  const fRoutingMode = useCpFormValue("advanced.spec.routingMode") || "";
  const fPortActiveKey = useCpFormValue("portActiveKey") || "";
  const fPorts = useCpFormValue("advanced.spec.ports") || [];

  if (fRoutingMode !== "workloadSubdomain") {
    return null;
  }

  if (fPorts.some((p) => (p.routes || []).length !== 1)) {
    const currentPort = fPorts.find((p) => p.id === fPortActiveKey);
    const margin = currentPort && (currentPort.routes || []).length > 0 ? "mb-8 -mt-4" : "mt-4";

    return (
      <>
        <Alert
          className={`${margin}`}
          type={`error`}
          message="Workload Subdomain Requirement"
          description="Routing Mode Workload Subdomain requires each port to have exactly one route defined"
        />
      </>
    );
  }

  return null;
};
